var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"message is-danger",class:_vm.messageClass},[(this.icon !== '')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.icon)}}):_vm._e(),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.body))])])
}
var staticRenderFns = []

export { render, staticRenderFns }